import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell';
import { physicianGuard } from '@app/auth/guards/physician.guard';
import { patientRoutes, PatientRoutingModule } from '@modules/cy/patient/patient-routing.module';
import {PatientSummaryComponent} from '@modules/cy/patient/ps/pages/patient-summary/patient-summary.component';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: 'cy',
      canActivate: [physicianGuard],
      children: patientRoutes,
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CYRoutingModule {}
